import { CancelTokenSource } from "axios";

export interface MapLayersState {
	MapLayer: {
		elevations?: any[];
		items?: any[];
		layers?: any[];
	};
	MapLayersBounds: any[];
	MapSelectedElevation: number;
	ManualRaiseMarkerPosition: any;
	ManualRaiseLayers: any[];
	ManualRaiseSelectedLayer: MapLayerData;
	MapItemIcons: any;
	BrokenMapItemIcons: any;
	MapLayersForGroup: any[];
	LayersHidden: Set<Number>;
	Elevation: number;
	ZoomLevel: string;
	MapLayersItemTypes: MapItemTypeData[];
	eventMarker: any;
	cancelTokenSource?: CancelTokenSource
}

export interface MapItemTypeData {
	mapLayerItemTypeID: number;
	title: string;
	visible: boolean;
	hideByDefault: boolean;
	icon: string;
}

export class MapItemData {
	public mapLayerItemID: number = 0;
	public mapLayerItemTypeID: number = 0;

	public minElevation: number | null = null;
	public maxElevation: number | null = null;

	public objectID: number | null = null;
	public extraValue: string = "";

	public title: string = "";
	public regionPath: string | null = null;
	public latLong: string | null = null;
	public mapLayerIds: number[] | null = null;

	public saved: boolean = true;
	public locationIdentifiers: MapItemLocationIdentifier[] = [];

	public brokenObjectLink: Boolean = false;
}

export class MapLayerData {
	public mapLayerID: number = 0;
	public minElevation: number | null = null;
	public maxElevation: number | null = null;
	public groupID: number = 0;
	public groupTitle: string = "";
	public title: string = "";
	public ne: string = "";
	public nw: string = "";
	public se: string = "";
	public sw: string = "";
	public image: string = "";
	public rotation: number = 0;
	public currentLevel: boolean | null = null;
}

export class MapLayer {
	public items: MapItemData[] = [];
	public layers: MapLayerData[] = [];
	public elevations: MapLayerElevation[] = [];
}

export class MapItemLocationIdentifierOption {
	id: number;
	title: string;
}

export class MapItemLocationIdentifier {
	mapLayerItemId: number;
	locationIdentifierId: string;
	locationIdentifierTypeId: number;
}

export interface MapLayerBounds {
	north: number;
	east: number;
	south: number;
	west: number;
}

export interface MapRequest extends MapLayerBounds {
	layersOnly: boolean;
	mapLayerItemTypeID?: number | null;
	elevation?: number | null;
	regionId?: number | null;
}

export interface MapLayerElevation {
	name: string;
	elevationValue: number;
}
